const R = require('ramda')

const REMOVE_ALL = 0
const KEEP_EMPTY_ARRAYS = 1
const KEEP_EMPTY_OBJECTS = 2
const KEEP_ALL = KEEP_EMPTY_ARRAYS | KEEP_EMPTY_OBJECTS

const isFilled = (v) => !R.isNil(v) && !R.isEmpty(v)

const canRemoveNulls = (data, flags = 0) => {
    if (R.isNil(data) || Number.isNaN(data) || data === '') {
        return true
    }

    const isArray = Array.isArray(data)
    const isObject = !isArray && typeof data === 'object'

    if (isArray && (flags & KEEP_EMPTY_ARRAYS)) {
        return false
    } else if (isObject && (flags & KEEP_EMPTY_OBJECTS)) {
        return false
    }

    return true
}

const removeNulls = (data, flags = KEEP_ALL, lastCheck = false) => {
    // console.log('removeNulls called', { data, flags, lastCheck })

    if (!isFilled(data)) {
        if (canRemoveNulls(data, flags)) {
            return null
        }
    }

    if (Array.isArray(data)) {
        return data
            .filter(_ => _ !== null)
            .map(i => removeNulls(i, flags))
    }

    if (data instanceof Object) {
        const newData = {}

        for (const [k, v] of Object.entries(data)) {
            if (typeof v === 'string') {
                if (R.trim(v) !== '') {
                    newData[k] = v
                }
            } else if (v === null || v === undefined || v === '' || Number.isNaN(v)) {
                // delete data[k]
            } else if (typeof v === 'object') {
                newData[k] = removeNulls(v, flags)
            } else {
                newData[k] = v
            }

            if (!isFilled(newData[k])) {
                if (canRemoveNulls(newData[k], flags)) {
                    delete newData[k]
                }
            }
        }

        if (!isFilled(newData)) {
            if (canRemoveNulls(newData, flags)) {
                return null
            }
        }

        return newData
    }

    if (lastCheck) {
        return data
    } else {
        return removeNulls(data, flags, true)
    }
}

removeNulls.KEEP_EMPTY_ARRAYS = KEEP_EMPTY_ARRAYS
removeNulls.KEEP_EMPTY_OBJECTS = KEEP_EMPTY_OBJECTS
removeNulls.KEEP_ALL = KEEP_ALL
removeNulls.REMOVE_ALL = REMOVE_ALL

module.exports = removeNulls

// const probes = [
//     [{}, REMOVE_ALL, null],
//     [{ p: null }, REMOVE_ALL, null],
//     [{ p: {}}, REMOVE_ALL, null],
//     [{ p: { c: null }}, REMOVE_ALL, null],
//     [{ p: [1] }, REMOVE_ALL, { p: [1] }],
//     [{ p: { c: 1 }}, REMOVE_ALL, { p: { c: 1 }}],
//     [{ p: 1 }, REMOVE_ALL, { p: 1 }],
//     [{ p: {}, q: [] }, KEEP_EMPTY_ARRAYS, { q: [] }],
//     [{ p: {}, q: [] }, KEEP_EMPTY_OBJECTS, { p: {}}],
//     [{ p: {}, q: [] }, KEEP_ALL, { p: {}, q: [] }]
// ]

// console.log(probes.map(([target, flags, expected]) => {
//     const result = removeNulls(target, flags)
//     if (result === expected) {} else if (R.equals(result, expected)) {} else {
//         console.error('Probe failed %O received %O expected %O', [target, flags, expected], result, expected)

//         return false
//     }

//     return true
// }).every(_ => _) ? 'All good with probes' : 'Probe failed')



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/remove-nulls.js